import lodashGet from 'lodash/get'

export default (props, traits) => {
  const banner = lodashGet(props, 'customSupporterPage.banner.url')
  const { colors, rhythm, scale, shadows, mediaQuery } = traits

  return {
    banner: {
      maxHeight: rhythm(20),
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    },

    image: {
      flexShrink: 0,
      width: '100%'
    },

    sidebar: {
      a: {
        maxWidth: '20em',
        width: '100%'
      },
      marginTop: banner && rhythm(-3),
      [mediaQuery('md')]: {
        marginTop: banner && rhythm(-7)
      },
      [mediaQuery('lg')]: {
        marginTop: banner && rhythm(-10)
      },

      '> div > * + *': {
        margin: rhythm([1.2, 0])
      },

      img: {
        maxWidth: '20em',
        margin: 'auto'
      }
    },

    main: {
      '> div > * + *': {
        margin: rhythm([2, 0])
      }
    },

    edit: {
      position: 'fixed',
      left: rhythm(1),
      bottom: rhythm(1),
      backgroundColor: colors.light,
      padding: rhythm([ 0.75, 1 ]),
      boxShadow: shadows.light,
      zIndex: 1
    },

    intro: {
      position: 'relative',
      paddingLeft: rhythm(2),
      fontSize: scale(-0.5),
      marginBottom: rhythm(0.75)
    },

    avatar: {
      position: 'absolute',
      width: rhythm(1.5),
      height: rhythm(1.5),
      borderRadius: '50%',
      top: 0,
      left: rhythm(-0.125)
    }
  }
}
